<template>
    <b-input-group>
        <b-form-input
            :id="id"
            v-model="value_.value"
            type="text"
            :placeholder="placeholder"
        />
        <b-form-select
            slot="append"
            v-model="value_.currency"
            :options="currencies.map((currency) => currency.currency_id)"
        />
    </b-input-group>
</template>

<script>
export default {

    props: {
        id: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        },
    },

    computed: {
        currencies() {
            return this.$store.getters['costable/currencies'];
        },
        value_: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },

};
</script>
